export default "__VITE_ASSET__D_OOtr8C__"